import styled from "styled-components";

export const AccordionBox = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ececec;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 16px;
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
  border-bottom: ${(props) => (props.active ? "1px solid #ececec" : "0px")};
  cursor: pointer;
  :hover {
    background-color: #ececec55;
  }
  color: #1b1b1b;
`;

export const AccordionTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

export const AccordionBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  transition: all 0.1s linear;
  overflow: hidden;
  ${(props) =>
    props.active
      ? "height: 100%;  padding: 16px;"
      : "height: 0px;  padding: 0px 16px;"}
`;
